var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',{staticClass:"level"},[_c('span',{staticClass:"level-item"},[_c('strong',{staticClass:"has-margin-right-small"},[_vm._v("\n                        "+_vm._s(_vm.meta.appName)+" v"+_vm._s(_vm.meta.version)+"\n                    ")])])])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21f9b32e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/core/structure/AppFooter.vue
// module id = XKM5
// module chunks = 66